<template>
  <div class="download_container">
    <div class="download-content">
      <!-- <div class="meteor"><div class="tail"></div></div>
      <div class="meteor"><div class="tail"></div></div>
      <div class="meteor"><div class="tail"></div></div>
      <div class="meteor"><div class="tail"></div></div>
      <div class="meteor"><div class="tail"></div></div>
      <div class="meteor"><div class="tail"></div></div>
      <div class="meteor"><div class="tail"></div></div>
      <div class="meteor"><div class="tail"></div></div> -->
      <div v-if="appInfo.downloadUrl == null" class="no-data">暂无App信息</div>
      <div class="logo-name" v-if="appInfo.downloadUrl">
        <img class="app-logo" :src="appInfo.appIcon" />
        <div class="app-name">{{ appInfo.appName }}</div>
      </div>
      <!-- <div class="down-botton-view"> -->
      <button class="down_button" @click="downLoadUrl" v-if="appInfo.downloadUrl">App下载</button>
      <!-- <button class="down_button">IOS下载</button> -->
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import { getAppDownloadInfo } from '@/api/operate.js'
export default {
  data() {
    return {
      appInfo: {}
    }
  },
  components: {},
  created() {
    let data = null
    if (this.$route.query.versionCode) {
      data = {
        appCode: this.$route.query.appCode,
        versionCode: this.$route.query.versionCode
      }
    } else {
      data = {
        appCode: this.$route.query.appCode
      }
    }
    getAppDownloadInfo(data)
      .then((res) => {
        this.appInfo = res.data
      })
      .catch(() => {})
  },
  mounted() {},
  methods: {
    downLoadUrl() {
      window.open(this.appInfo.downloadUrl)
    }
  }
}
</script>
<style lang="scss" scoped>
.download_container {
  background: #fff;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 50px;
  .download-content {
    // background-image: url(../../assets/xingkong.jpg);
    // background-repeat: no-repeat;
    // border: 1px solid #409eff;
    position: relative;
    margin: auto;
    height: 600px;
    width: 345px;
    overflow: hidden;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .no-data {
      font-size: 18px;
      margin: auto;
    }
    .meteor {
      position: absolute;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      pointer-events: none;
      opacity: 0;
      z-index: 9;
    }
    /* 流行尾巴 */
    .meteor .tail {
      position: absolute;
      width: 100px;
      height: 2px;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      background: linear-gradient(to left, currentColor, transparent);
    }
    .meteor:nth-child(1) {
      color: #ff9a9e;
      top: 10%;
      left: 150px;
      animation: meteor 3s linear infinite;
    }
    .meteor:nth-child(2) {
      color: #4facfe;
      top: 20%;
      left: 150px;
      animation: meteor 3s linear infinite 1s;
    }
    .meteor:nth-child(3) {
      color: #81fbb8;
      top: 30%;
      left: 150px;
      animation: meteor 3s linear infinite 0.5s;
    }
    .meteor:nth-child(4) {
      color: #ffd34f;
      top: 40%;
      left: 150px;
      animation: meteor 3s linear infinite 1.5s;
    }
    .meteor:nth-child(5) {
      color: #c471f5;
      top: 50%;
      left: 150px;
      animation: meteor 3s linear infinite 0.8s;
    }
    .meteor:nth-child(6) {
      color: #43e97b;
      top: 60%;
      left: 150px;
      animation: meteor 3s linear infinite 2s;
    }
    .meteor:nth-child(7) {
      color: #fa71cd;
      top: 70%;
      left: 150px;
      animation: meteor 3s linear infinite 1.2s;
    }
    .meteor:nth-child(8) {
      color: #a8c0ff;
      top: 80%;
      left: 150px;
      animation: meteor 3s linear infinite 0.3s;
    }

    @keyframes meteor {
      0% {
        opacity: 0;
        transform: translate(0, 0) rotate(45deg);
      }
      10% {
        opacity: 1;
      }
      20% {
        transform: translate(30px, 30px) rotate(45deg);
      }
      40% {
        transform: translate(60px, 60px) rotate(45deg);
      }
      60% {
        transform: translate(90px, 90px) rotate(45deg);
        opacity: 1;
      }
      100% {
        transform: translate(120px, 120px) rotate(45deg);
        opacity: 0;
      }
    }

    .logo-name {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 10;
      .app-logo {
        width: 100px;
        height: 100px;
        margin-top: 100px;
        border-radius: 5px;
      }
      .app-name {
        font-size: 18px;
        margin-top: 15px;
      }
    }

    // .down-botton-view{
    //   display: flex;
    //   justify-content: space-between;
    //   margin-bottom: 20px;
    //   width: 60%;
    // }
    .down_button {
      width: 100px;
      height: 35px;
      border: none;
      border-radius: 5px;
      color: rgba(255, 255, 255, 1);
      background: linear-gradient(90deg, #409eff 0%, #409eff 100%);
      font-size: 16px;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      margin-bottom: 20px;
      transition: background-color 0.3s ease;
    }

    .down_button::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
      transform: skewX(-45deg);
      animation: streamer 2s infinite;
    }
    // 流光动画
    @keyframes streamer {
      0% {
        left: -100%;
      }
      100% {
        left: 100%;
      }
    }
  }
}
</style>
